import {
  AI_DISCLAIMER_TOGGLE,
  FETCH_ASSESSMENT_ERROR,
  FETCH_ASSESSMENT_START,
  FETCH_ASSESSMENT_SUCCESS,
  GET_ASSESSMENT,
  SSI_DOCUMENT_NUMBER_CHANGE,
} from './types';
import { AssessmentPayload } from 'types/assessment-payload';
import { SelectedSsiVersion } from 'components/dropdown';

export const ERROR_MESSAGE =
  'Error happened while loading, try reloading the page';

export interface IAIDisclaimer {
  type: typeof AI_DISCLAIMER_TOGGLE;
  isDisclaimerOpen: boolean;
}

interface IFetchAssessmentAction {
  type: typeof GET_ASSESSMENT;
  documentId: string;
  documentVersion: string;
  ssiDocumentNumber?: SelectedSsiVersion;
}

export interface IFetchAssessmentStart {
  type: typeof FETCH_ASSESSMENT_START;
}

export interface IFetchAssessmentSuccess {
  type: typeof FETCH_ASSESSMENT_SUCCESS;
  assessment: AssessmentPayload;
}

export interface IFetchAssessmentError {
  type: typeof FETCH_ASSESSMENT_ERROR;
  error: {
    message: string;
    statusCode: number;
  };
}

export interface ISsiDocumentNumberChange {
  type: typeof SSI_DOCUMENT_NUMBER_CHANGE;
  selectedSsiDocumentNumber: string[];
}

export function changeSsiDocumentNumberAction(
  selectedSsiDocumentNumber: string[]
): ISsiDocumentNumberChange {
  return {
    type: SSI_DOCUMENT_NUMBER_CHANGE,
    selectedSsiDocumentNumber,
  };
}

export function fetchAssessmentAction(
  documentId: string,
  documentVersion: string,
  ssiDocumentNumber?: SelectedSsiVersion
): IFetchAssessmentAction {
  return {
    type: GET_ASSESSMENT,
    documentId,
    documentVersion,
    ssiDocumentNumber,
  };
}

export function fetchAssessmentStartAction(): IFetchAssessmentStart {
  return {
    type: FETCH_ASSESSMENT_START,
  };
}

export function fetchAssessmentSuccessAction(
  assessment: AssessmentPayload
): IFetchAssessmentSuccess {
  return {
    type: FETCH_ASSESSMENT_SUCCESS,
    assessment,
  };
}

export function fetchAssessmentErrorAction(
  statusCode: number,
  message = ERROR_MESSAGE
): IFetchAssessmentError {
  return {
    type: FETCH_ASSESSMENT_ERROR,
    error: {
      message,
      statusCode,
    },
  };
}

export function toggleAIDisclaimer(isDisclaimerOpen: boolean) {
  return {
    type: AI_DISCLAIMER_TOGGLE,
    isDisclaimerOpen,
  };
}
